<!-- Botón y no `img` con `(click)`: hace falta llegar con el teclado y con Enter. -->
<button
  *ngIf="url; else noReceipt"
  type="button"
  class="expense-receipt-button"
  [attr.aria-label]="'expenses.receipt_expand' | translate"
  (click)="open()"
>
  <img
    class="expense-receipt"
    [src]="url"
    [alt]="'expenses.receipt_attached' | translate"
    loading="lazy"
  />
</button>

<ng-template #noReceipt>
  <span
    class="expense-receipt-empty"
    [attr.aria-label]="'expenses.no_receipt' | translate"
    >{{ 'expenses.no_value' | translate }}</span
  >
</ng-template>
